<template>
  <div class="add-test-dialog" v-loading="loading">
    <div class="add-tests-navbar">
      <el-row type="flex" align="middle">
        <el-col :span="4">
          <h3 class="heading">SELECT TESTS</h3>
        </el-col>
        <el-col :span="16">
          <div class="navbar-search">
            <div
              class="form-group"
              v-if="listOfTests && Object.keys(listOfTests) && havingCaseTypes"
            >
              <el-autocomplete
                v-model="searchTestString"
                :fetch-suggestions="getAutoCompleteTestsData"
                placeholder="SEARCH"
                :clearable="true"
                @select="selectedString($event)"
                :trigger-on-focus="false"
                class="el-input"
              ></el-autocomplete>

              <span class="search-icon">
                <img
                  src="@/assets/images/icons/search-icon-dark-blue.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="close-popup">
            <el-button size="medium" class="" type="info" @click="closeDialog">
              <img src="@/assets/images/close-icon.svg" alt="icon"
            /></el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="select-tests-popup">
      <el-row>
        <el-col :span="14">
          <div class="selection-tests-group">
            <div class="test-panels" v-if="getCaseTypes && getCaseTypes.length">
              <el-tabs v-model="activeName" >
                <el-tab-pane
                  v-for="(caseType, index) of getCaseTypes"
                  :key="index"
                  :label="caseType.label"
                  :name="caseType.label"
                >
                  <div v-if="!loading">
                    <div v-if="caseType.value == 'TOXICOLOGY'">
                      <ToxicologyPanelTestSelection
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                        v-on:onUncheckedSelection="removeUnchecked"
                        v-on:onCheckedSelection="onCheckedSelection"
                        :checklistData="setSelectedOrderCheckList"
                        :specimenData="setSelectedSpecimen"
                      >
                      </ToxicologyPanelTestSelection>
                    </div>
                    <div
                      class="wound-panel-test-selections"
                      v-else-if="caseType.value == 'WOUND'"
                    >
                      <WoundPanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                      ></WoundPanelTestSelection>
                    </div>
                    <div v-else-if="caseType.value == 'UTI'">
                      <UTIPanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                      ></UTIPanelTestSelection>
                    </div>
                    <div v-else-if="caseType.value == 'URINE_CULTURE'">
                      <UrineCulturePanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                      ></UrineCulturePanelTestSelection>
                    </div>
                    <div v-else-if="caseType.value == 'ENT'">
                      <ENTPanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                      ></ENTPanelTestSelection>
                    </div>
                    <div v-else-if="caseType.value == 'NAIL'">
                      <NailPanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                      >
                      </NailPanelTestSelection>
                    </div>
                    <div v-else-if="caseType.value == 'GASTRO'">
                      <GastroPanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                      >
                      </GastroPanelTestSelection>
                    </div>
                    <div v-else-if="caseType.value == 'CLINICAL_CHEMISTRY'">
                      <BloodPanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                      ></BloodPanelTestSelection>
                    </div>
                    <div v-else-if="caseType.value == 'STI'">
                      <GTIWomensSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                      ></GTIWomensSelection>
                    </div>
                    <div v-else-if="caseType.value == 'URINALYSIS'">
                      <UrinalysisPanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                        :caseTypesData="getCaseTypes"
                      ></UrinalysisPanelTestSelection>
                    </div>
                    <div
                      v-else-if="caseType.value == 'RESPIRATORY_PATHOGEN_PANEL'"
                    >
                      <RespiratoryPanelTestSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                        :caseTypesData="getCaseTypes"
                      ></RespiratoryPanelTestSelection>
                    </div>
                    <div v-else-if="caseType.value == 'WOMENS_HEALTH'">
                      <WomensHealthSelection
                        v-if="!loading"
                        :panelTestsData="panelsTestsData"
                        :searchString="searchString"
                        :caseTypesData="getCaseTypes"
                      ></WomensHealthSelection>
                    </div>
                    <div v-else>
                      <ul :class="caseType.value.toLowerCase()">
                        <li
                          class="each-test"
                          v-for="(category, index) of getCaseCategoryData(
                            caseType.value
                          )"
                          :key="index"
                        >
                          <el-collapse v-model="activeNameCollapse" accordion>
                            <el-collapse-item :name="index">
                              <template #title>
                                <el-checkbox
                                  class="el-collapse-checkbox"
                                  style="
                                    position: relative;
                                    top: 2px;
                                    padding: 0 10px 0 0;
                                  "
                                  :model-value="
                                    isCheckAll(
                                      category.case_type_code,
                                      category.panel_id
                                    )
                                  "
                                  @change="
                                    checkAll(
                                      $event,
                                      category.case_type_code,
                                      category.panel_id
                                    )
                                  "
                                ></el-checkbox
                                >{{ category.panel_title }}</template
                              >
                              <el-checkbox
                                :model-value="
                                  isCheckAll(
                                    category.case_type_code,
                                    category.panel_id
                                  )
                                "
                                @change="
                                  checkAll(
                                    $event,
                                    category.case_type_code,
                                    category.panel_id
                                  )
                                "
                                >All</el-checkbox
                              >
                              <el-checkbox-group
                                v-model="selectedCategoriesWithTests"
                              >
                                <div
                                  v-for="(
                                    item, index
                                  ) of getCategoryWiseTestsData(
                                    category.case_type_code,
                                    category.panel_code
                                  )"
                                  :key="index"
                                >
                                  <div>
                                    <div
                                      class="each-check-box"
                                      v-if="category.case_type_code == 'STI'"
                                    >
                                      <el-checkbox
                                        :label="item.label_value"
                                        disabled
                                        >{{ item.test_name }}</el-checkbox
                                      >
                                    </div>
                                    <div class="each-check-box" v-else>
                                      <el-checkbox
                                        :label="item.label_value"
                                        disabled
                                        @change="
                                          checkSingleTest(
                                            $event,
                                            category.case_type_code,
                                            category.panel_id,
                                            item._id
                                          )
                                        "
                                        >{{ item.test_name }}</el-checkbox
                                      >
                                    </div>
                                  </div>
                                </div>
                              </el-checkbox-group>
                            </el-collapse-item>
                          </el-collapse>
                        </li>
                      </ul>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="current-selected-tests">
            <div class="c_header">
              <h4>CURRENT SELECTION</h4>
            </div>
            <div class="c_body">
              <div class="inside-scroll">
                <div
                  class="each-item"
                  v-for="(
                    categoryData, index
                  ) of panelsTestsData.selectedCategories"
                  :key="index"
                >
                  <h4 class="category-name">
                    {{ getCategoryTitle(categoryData.panel_id) }}
                  </h4>
                  <div class="selected-tests-list-group">
                    <ul class="selected-tests-list">
                      <li
                        v-for="(testId, index) of categoryData.test_ids"
                        :key="index"
                      >
                        <span class="test-name">
                          {{ getTestNameById(testId) }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="each-item"
                  v-for="(categoryData, index) of getCategoriesFromGroups(
                    panelsTestsData.selectedGroup
                  )"
                  :key="index"
                >
                  <h4 class="category-name">
                    {{ getCategoryTitle(categoryData.panel_id) }}
                  </h4>
                  <div class="selected-tests-list-group">
                    <ul class="selected-tests-list">
                      <li
                        v-for="(testId, index) of categoryData.test_ids"
                        :key="index"
                      >
                        <span class="test-name">
                          {{ getTestNameById(testId) }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="add-test-button">
                <el-button @click="addTests"> Add Test</el-button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import caseConstants from "@/config/constants/caseConstants";
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";

import { defineAsyncComponent } from "vue";
const WoundPanelTestSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/WoundPanelTestSelection")
);
const UTIPanelTestSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/UTIPanelTestSelection")
);
const UrineCulturePanelTestSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/UrineCulturePanelTestSelection")
);
const ENTPanelTestSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/ENTPanelTestSelection")
);
const NailPanelTestSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/NailPanelTestSelection")
);
const GastroPanelTestSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/GastroPanelTestSelection")
);
const ToxicologyPanelTestSelection = defineAsyncComponent(() =>
  import("@/components/panels/testSelection/ToxicologyPanelTestSelection")
);
const BloodPanelTestSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/BloodPanelTestSelection")
);
const GTIWomensSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/GTIWomensSelection")
);
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

const UrinalysisPanelTestSelection = defineAsyncComponent(() =>
  import("@/components/panels/testSelection/UrinalysisPanelTestSelection")
);
const RespiratoryPanelTestSelection = defineAsyncComponent(() =>
  import("@/components/panels/testSelection/RespiratoryPanelTestSelection")
);
const WomensHealthSelection = defineAsyncComponent(() =>
  import("./testInfo/testSelection/WomensHealthSelection")
);
export default {
  data() {
    return {
      activeNameCollapse: "",
      search_case_types: caseConstants.CASE_TYPES_DATA,
      activeName: "first",
      checked: false,
      testsData: [],
      searchString: "",
      loading: false,
      searchTestString: null,
      screeningChecked: false,
      confirmationChecked: false,
      etgChecked: false,
      BloodPanels: [],
      UTIPanels: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
        selectedTestsInfo: [],
      },
      listOfTests: [],
      categoryTestList: [],
      selectedPanel: [],
      TestProfiles: [],
      selectedTestProfile: [],
      selectedProfileTests: [],
      selectedTestProfileIds: {},
      app: null,
      setSelectedOrderCheckList: this.selectedChecklist,
      setSelectedSpecimen: this.selectedSample,
      TOX_CONFORMATION_TESTS: caseConstants.TOX_CONFORMATION_TESTS,
      TOX_CATEGORIES: caseConstants.TOX_CATEGORY_TESTS,
      selectedCheckbox: null,
      userType: "",
      selectedCategories: [],
      selectedCategoriesWithTests: [],
    };
  },
  mixins: [AppHelper, UserPermissionsHelper],
  components: {
    WoundPanelTestSelection,
    UTIPanelTestSelection,
    UrineCulturePanelTestSelection,
    ENTPanelTestSelection,
    BloodPanelTestSelection,
    ToxicologyPanelTestSelection,
    NailPanelTestSelection,
    GastroPanelTestSelection,
    GTIWomensSelection,
    UrinalysisPanelTestSelection,
    RespiratoryPanelTestSelection,
    WomensHealthSelection,
  },
  props: [
    "caseTypes",
    "panelsTestsDataUnchanged",
    "selectedOrdersCheckList",
    "selectedChecklist",
    "selectedSample",
  ],
  computed: {
    // ...mapGetters("labTests", [
    //   "getNewLabGroupPanelTests",
    // ]),
    ...mapGetters("cases", ["getCaseInformation"]),
    ...mapGetters("auth", ["getUserPrimaryLabId"]),
    allCaseTypes() {
      return this.search_case_types;
    },
    selectedTestsDetails() {
      const data = [];
      if (
        this.panelsTestsData.selectedTestIds &&
        this.getNewLabGroupPanelTests
      ) {
        const tests = this.getNewLabGroupPanelTests;
        this.panelsTestsData.selectedTestIds.forEach((selected) => {
          const matched = tests.find(
            (test) =>
              test._id === selected._id && test.panel_id === selected.panel_id
          );
          if (matched) {
            data.push({
              ...matched,
              panel_id: selected.panel_id,
            });
          }
        });
      }
      return data;
    },
    havingCaseTypes() {
      if (
        this.caseTypes &&
        this.caseTypes.length &&
        (this.caseTypes.indexOf("UTI") > -1 ||
          this.caseTypes.indexOf("WOUND") > -1) &&
        (this.activeName == "UTI" || this.activeName == "WOUND")
      ) {
        return false;
      }
      return true;
    },
    getCaseTypes() {
      if (this.caseTypes && this.caseTypes.length) {
        return this.allCaseTypes.filter(
          (el) => this.caseTypes.indexOf(el.value) > -1
        );
      } else if (
        this.getCaseInformation &&
        this.getCaseInformation.case_types &&
        this.getCaseInformation.case_types.length
      ) {
        return this.allCaseTypes.filter(
          (el) => this.getCaseInformation.case_types.indexOf(el.value) > -1
        );
      }
      return [];
    },
    getCategoryTitle() {
      return (id) =>
        this.getNewLabGroupPanelTests.find((e) => e.panel_id == id).panel_title;
    },
    getTestNameById() {
      return (id) =>
        this.getNewLabGroupPanelTests.find((e) => e._id == id).test_name;
    },
  },
  async mounted() {
    try {
      this.loading = true;
      let caseTypes = this.getCaseTypes;
      let caseTypeValues = caseTypes.map((e) => {
        return e.value;
      });

      if (caseTypes && caseTypes.length && caseTypes[0].label) {
        this.activeName = caseTypes[0].label;
      }
      // await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
      //   get_all: true,
      //   lab_id: this.getUserPrimaryLabId,
      //   case_type_code: caseTypeValues,
      //   status: "ACTIVE",
      // });
      // await this.$store.dispatch("labTests/fetchLabPanelsWiseTests", {
      //   get_all: true,
      //   lab_id: this.getUserPrimaryLabId,
      //   case_type_code: caseTypeValues,
      //   status: "ACTIVE",
      // });
      if (
        this.getNewLabGroupPanelTests &&
        this.getNewLabGroupPanelTests.length
      ) {
        let group = this.getNewLabGroupPanelTests.reduce((r, a) => {
          r[a.panel_title] = [...(r[a.panel_title] || []), a];
          return r;
        }, {});
        this.listOfTests = group;
      }
      this.categoryTestList = this.getNewLabGroupPanelTests;
      let tests = Object.keys(this.listOfTests);
      let covidTests = ["COVID 19", "COVID AND FLU"];
      for (let i = 0; i < tests.length; i++) {
        if (!covidTests.includes(tests[i])) {
          this.categoryTestList.push({
            test_name: tests[i],
          });
        }
        // }
      }

      this.panelsTestsData.selectedCategories =
        [...this.panelsTestsDataUnchanged.selectedCategories] || [];

      this.panelsTestsData.selectedGroup =
        [...this.panelsTestsDataUnchanged.selectedGroup] || [];

      this.loading = false;
      // eslint-disable-next-line no-empty
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  },
  methods: {
    getAutoCompleteTestsData(queryString, cb) {
      let patientsData = [];

      let links = this.categoryTestList;
      let results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      if (results && results.length) {
        results.forEach((el) => {
          if (el.panel_title) {
            patientsData.push({
              value: el.test_name + " - " + "[" + el.panel_title + "]",
              ...el,
            });
          }
          // else {
          //   patientsData.push({
          //     value: el.name,
          //     ...el,
          //   });
          // }
        });

        patientsData = patientsData.filter(
          (test) => this.panelsTestsData.selectedTestIds.indexOf(test._id) == -1
        );
        patientsData = patientsData.filter(
          (test) => this.selectedPanel.indexOf(test.test_name) == -1
        );
        cb(patientsData);
      } else {
        cb([]);
      }

      // call callback function to return suggestions
    },
    createFilter(queryString) {
      return (link) => {
        if (this.getCaseTypes[0].value === "CLINICAL_CHEMISTRY") {
          return (
            link.test_name.toLowerCase().includes(queryString.toLowerCase()) &&
            (link.panel_title === "All Tests" ||
              link.panel_title === "Send Outs")
          );
        } else if (this.getCaseTypes[0].value === "TOXICOLOGY") {
          return (
            link.test_name.toLowerCase().includes(queryString.toLowerCase()) &&
            link.panel_title !== "Screening"
          );
        } else if (this.getCaseTypes[0].value === "URINALYSIS") {
          return null;
        } else {
          return link.test_name
            .toLowerCase()
            .includes(queryString.toLowerCase());
        }
      };
    },
    selectedString(testData) {
      if (testData) {
        const existingPanel = this.panelsTestsData.selectedCategories.find(
          (item) => item.panel_id === testData.panel_id
        );
        if (existingPanel) {
          // Only add test_id if it doesn't already exist
          if (!existingPanel.test_ids.includes(testData._id)) {
            existingPanel.test_ids.push(testData._id);
          }
        } else {
          // If not existing, create a new entry
          this.panelsTestsData.selectedCategories.push({
            panel_id: testData.panel_id,
            test_ids: [testData._id],
            case_type_code: testData.case_type_code,
          });
        }
      }
      this.searchTestString = "";
    },
    getCategoryWiseTestsData(caseType, category) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.panel_code === category &&
            (el.test_name
              .toLowerCase()
              .includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) => el.case_type_code === caseType && el.panel_code === category
        );
      }

      return this.sortByKey(data, "test_name");
    },
    getCategoryIdWiseTestsData(caseType, categoryId) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.panel_id === categoryId &&
            (el.test_name
              .toLowerCase()
              .includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) => el.case_type_code === caseType && el.panel_id === categoryId
        );
      }

      data = data.map((e) => {
        e.label_value = e.panel_id + ":" + e._id;
        return e;
      });

      return this.sortByKey(data, "test_name");
    },
    getCaseCategoryData(caseType) {
      const data = this.getNewLabGroupPanelTests.filter((el) => {
        const matchesCaseType = el.case_type_code === caseType;
        const matchesSearch =
          !this.searchString ||
          el.test_name
            .toLowerCase()
            .includes(this.searchString.toLowerCase()) ||
          el.panel_title
            .toLowerCase()
            .includes(this.searchString.toLowerCase());

        return matchesCaseType && matchesSearch;
      });

      let flags = {};
      let outputWithFullDetails = [];

      for (let i = 0; i < data.length; i++) {
        const code = data[i].panel_code;

        if (flags[code]) continue;

        flags[code] = true;
        outputWithFullDetails.push(data[i]);
      }

      return outputWithFullDetails;
    },

    addTests() {
      let seen = new Set();
      let rawPanels = Array.isArray(this.getNewLabGroupPanelTests)
        ? this.getNewLabGroupPanelTests
            .map((e) => ({
              panel_id: e.panel_id,
              panel_code: e.panel_code,
            }))
            .filter((item) => {
              if (seen.has(item.panel_id)) return false;
              seen.add(item.panel_id);
              return true;
            })
        : [];

      let filterPanels = this.panelsTestsData.selectedCategories.map((e) => ({
        panel_id: e.panel_id,
      }));

      let allowedIds = new Set(filterPanels.map((item) => item.panel_id));

      let filteredPanels = rawPanels.filter((item) =>
        allowedIds.has(item.panel_id)
      );

      let selectedCategories = filteredPanels;
      if (
        this.setSelectedOrderCheckList &&
        this.setSelectedOrderCheckList.includes(
          "Screen and Confirm Tests Selected Below"
        )
      ) {
        let hasConfirmationTest = false;

        // Check if any selected category code is in the TOX_CONFORMATION_TESTS array
        for (let i = 0; i < selectedCategories.length; i++) {
          if (
            this.TOX_CONFORMATION_TESTS.includes(
              selectedCategories[i].panel_code
            )
          ) {
            hasConfirmationTest = true;
            break;
          }
        }
        if (!hasConfirmationTest) {
          // Show popup here
          alert("Please select at least one confirmation");
          return; // Stop execution if confirmation tests are not selected
        }
      }
      if (
        this.setSelectedOrderCheckList &&
        this.setSelectedOrderCheckList.includes("Confirm Tests Selected Below")
      ) {
        let hasToxicologyCategory = false;

        // Check if any selected category code is in the TOX_CATEGORIES array
        for (let i = 0; i < selectedCategories.length; i++) {
          if (this.TOX_CATEGORIES.includes(selectedCategories[i].panel_code)) {
            hasToxicologyCategory = true;
            break;
          }
        }
        if (!hasToxicologyCategory) {
          // Show popup here
          alert("Please select at least one confirmation");
          return; // Stop execution if confirmation tests are not selected
        }
      }
      this.$emit("addTestsData", {
        data: this.panelsTestsData,
        allTests: this.selectedTestsDetails,
      });
    },
    closeDialog() {
      this.$emit("addTestsData");
    },
    onCheckedSelection(subCategory) {
      if (this.selectedPanel && !this.selectedPanel.includes(subCategory)) {
        this.selectedPanel.push(subCategory);
      }
    },
    removeUnchecked(subCategory) {
      this.selectedPanel = this.selectedPanel.filter(
        (test) => subCategory.indexOf(test) == -1
      );
      var found = false;
      for (var i = 0; i < this.categoryTestList.length; i++) {
        if (this.categoryTestList[i].test_name == subCategory) {
          found = true;
          break;
        }
      }
      if (
        this.selectedPanel.length &&
        !this.selectedPanel.includes(subCategory) &&
        !found
      ) {
        this.categoryTestList.push({
          test_name: subCategory,
        });
      } else if (!this.selectedPanel.includes(subCategory) && !found) {
        this.categoryTestList.push({
          test_name: subCategory,
        });
      }
    },

    checkAll(data, caseType, panelId) {
      if (data) {
        this.panelsTestsData.selectedCategories.push({
          panel_id: panelId,
          case_type_code: caseType,
          all_tests: true,
          test_ids: this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e._id),
        });

        this.selectedCategoriesWithTests = [
          ...this.selectedCategoriesWithTests,
          ...this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e.label_value),
        ];
      } else {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (e) => e.panel_id == panelId && e.case_type_code == caseType
        );
        if (index > -1) {
          let panelId = this.panelsTestsData.selectedCategories[index].panel_id;
          let testIds = this.getNewLabGroupPanelTests
            .filter((e) => e.panel_id == panelId)
            .map((e) => e.label_value);
          this.selectedCategoriesWithTests =
            this.selectedCategoriesWithTests.filter(
              (e) => !testIds.includes(e)
            );
          this.panelsTestsData.selectedCategories.splice(index, 1);
        }
      }
    },
    isCheckAll(caseType, category) {
      let selectedCategory = this.panelsTestsData.selectedCategories.find(
        (selectedCategory) =>
          selectedCategory.case_type_code == caseType &&
          selectedCategory.panel_id == category
      );

      if (selectedCategory) {
        let categoryTestInfo = this.getCategoryIdWiseTestsData(
          caseType,
          selectedCategory.panel_id
        );
        if (categoryTestInfo.length == selectedCategory.test_ids.length) {
          return true;
        }
        return false;
      }
      return false;
    },
    checkSingleTest(data, caseType, category, testId) {
      if (data) {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (selectedCategory) =>
            selectedCategory.case_type_code == caseType &&
            selectedCategory.panel_id == category
        );

        if (index > -1) {
          if (
            this.panelsTestsData.selectedCategories[index] &&
            this.panelsTestsData.selectedCategories[index].test_ids
          ) {
            this.panelsTestsData.selectedCategories[index].test_ids.push(
              testId
            );
          } else {
            this.panelsTestsData.selectedCategories[index].test_ids = [testId];
          }
        } else {
          this.panelsTestsData.selectedCategories.push({
            panel_id: category,
            case_type_code: caseType,
            all_tests: false,
            test_ids: [testId],
          });
        }
      } else {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (selectedCategory) =>
            selectedCategory.case_type_code == caseType &&
            selectedCategory.panel_id == category
        );

        if (index > -1) {
          if (
            this.panelsTestsData.selectedCategories[index] &&
            this.panelsTestsData.selectedCategories[index].test_ids
          ) {
            let testIndex = this.panelsTestsData.selectedCategories[
              index
            ].test_ids.findIndex((e) => e == testId);
            if (testIndex > -1) {
              this.panelsTestsData.selectedCategories[index].test_ids.splice(
                testIndex,
                1
              );
            }
            if (
              this.panelsTestsData.selectedCategories[index].test_ids.length ==
              0
            ) {
              this.panelsTestsData.selectedCategories.splice(index, 1);
            }
          }
        }
      }
    },
    getCategoriesFromGroups(selectedGroup) {
      let panelIds = selectedGroup.map((group) => group.panel_ids).flat();

      let data = this.getNewLabGroupPanelTests.filter((e) =>
        panelIds.includes(e.panel_id)
      );

      let categories = data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      categories = categories.map((category) => {
        category.test_ids = data
          .filter((e) => e.panel_id == category.panel_id)
          .map((e) => e._id);
        return category;
      });

      return categories;
    },
  },
};
</script>

<style lang="scss">
@mixin search-bar {
  border-radius: 5px;
  height: 30px;
  border: none;
}

.add-test-dialog {
  .add-tests-navbar {
    align-items: center;
    background: #05af3d;
    border-radius: 5px 6px 0px 0px;
    padding: 5px 15px 5px 25px;
    color: #fff;

    .navbar-search {
      width: 80%;
      margin: 0 auto;
      position: relative;
    }

    .form-group {
      display: flex;
      justify-content: center;

      span {
        right: 30px;
      }

      .search-icon {
        position: absolute;
        top: 4px;
        width: 22px;
        height: 22px;
        right: 5px;
      }

      .el-input__inner {
        font-weight: 500;
        color: #333;
      }
    }

    .close-popup {
      display: flex;
      justify-content: flex-end;

      .el-button {
        background: none;
        padding: 0;
        border: none;
      }
    }
  }

  .test-popup {
    h3 {
      color: #ffffff;
      margin: 0;
      padding: 0 25px 0 10px;
    }
  }

  .el-input--suffix .el-input__inner {
    @include search-bar;
  }

  .selection-tests-group {
    .test-panels {
      .el-tabs {
        .el-tabs__item.is-active {
          color: #273480;
        }

        .el-tabs__active-bar {
          background-color: #273480;
          border-radius: 25px;
          bottom: 5px;
          height: 1.5px;
        }

        .el-tabs__nav-wrap {
          padding: 0 20px;
        }

        .el-tabs__nav-wrap::after {
          background-color: #e7e7f7;
          height: 1px;
        }

        .el-tabs__content {
          height: 500px;
          overflow: auto;
          margin-right: 5px;

          @media (min-width: 1700px) {
            height: 670px;
          }
        }
      }

      .all-tests {
        padding-bottom: 15px;
      }

      .test-panels-list {
        display: flex;
        width: 100%;

        .test-panels-list-left {
          width: 50%;

          ul {
            display: flex;

            li {
              color: #4f4f4f;
              font-weight: 500;
              font-size: 15px;
            }
          }
        }

        .test-panels-list-right {
          width: 48%;
          display: flex;
          justify-content: right;

          .el-button {
            padding: 0;
            border: none;
            color: #219653;
            background: transparent;

            &:active {
              color: #219653;
              background: transparent;
            }
          }
        }
      }

      .tests-list {
        ul {
          display: flex;

          li {
            padding: 10px 5px;

            .el-checkbox:last-of-type {
              border: none;
              background: #ffffff;
              padding: 0 7px;
            }
          }
        }
      }

      .text-check-box {
        display: flex;
      }

      .el-checkbox {
        height: 26px;
        align-items: flex-start;
      }

      .el-checkbox__input .el-checkbox__inner {
        border-color: transparent;
        box-shadow: 0 0 0 1px #ced1d6;
        border-radius: 4px;
        width: 17px;
        margin-top: 3.5px;
        height: 17px;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #273480;
        border-color: #ffffff;
        box-shadow: 0 0 0 1px #ced1d6;
        width: 17px;
        height: 17px;
      }

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #273480;
      }

      .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        border: 2px solid var(--el-checkbox-checked-icon-color);
        border-left: 0;
        border-top: 0;
        height: 9px;
        left: 5.5px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleY(1);
        width: 3px;
        transition: transform 0.15s ease-in 50ms;
        transform-origin: center;
      }

      .el-checkbox__label {
        color: #34495e;
      }

      .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        row-gap: 8px;

        & > div {
          width: 33.33%;
          padding: 3px 0;
        }

        .each-checkbox-test {
          width: 25%;
        }

        .each-check-box {
          margin-right: 10px;

          .el-checkbox__label {
            position: relative;
            top: 3px;
            line-height: 18px;
          }
        }
      }

      .el-collapse-item__arrow {
        color: #4f4f4f;
        font-size: 21px;
        position: absolute;
        right: 20px;
      }

      .el-checkbox__label {
        position: relative;
        top: 5px;
        font-size: 13px;
        white-space: pre-wrap;
      }
    }

    .test-panels {
      .each-test {
        &:not(:last-child) {
          margin-bottom: 0px;
        }

        .el-collapse {
          width: 96%;
          margin: auto;
          --el-collapse-border-color: none;
          --el-collapse-border-color: none !important;
          border: none;
        }

        .el-collapse-item__header {
          border: none !important;
          padding: 5px 15px;
          border-radius: 6px;
          color: #4f4f4f;
          font-size: 14px;
          font-weight: 500;
          height: auto;
          height: 30px;

          .all-orders-img {
            width: 10px;
            padding: 10px 5px 0 5px;

            img {
              width: 10px;
              height: 10px;
            }
          }
        }

        .el-collapse-item__wrap {
          border: none;
        }

        .el-collapse-item__header.is-active {
          border: none;
        }

        .el-collapse-item__content {
          --el-collapse-border-color: none;
          padding: 10px 5px 15px 15px;
          overflow: auto;
        }
      }

      .el-tabs__content {
        .each-test:nth-child(odd) {
          .el-collapse-item__header {
            background-color: #f2f2f2;
            border-radius: 6px;
          }
        }
      }
    }
  }

  .blood-inner-tab {
    .el-tabs__nav-scroll {
      padding: 0 20px;
    }
  }
}
</style>
